import { useLocation } from '@reach/router';
import queryString from 'query-string';

export default function useVariantIdParam() {
  const location = useLocation();
  return queryString.parse(location.search)?.variant;
}
